import axios from "axios";
import { notify } from "@kyvg/vue3-notification";


export const getCNPJ = async (cnpj) => {
  try {
    // use data destructuring to get data from the promise object
    const { data: response } = await axios.get('https://brasilapi.com.br/api/cnpj/v1/' + cnpj);
    return response;
  } catch (error) {
    notify({
      title: "Falha",
      text: "CNPJ não encontrado!",
      type: 'error'
    });
  }
};

export const getCNPJAlternative = async (cnpj) => {
  try {
    // use data destructuring to get data from the promise object
    const { data: response } = await axios.get('https://api.opencnpj.org/' + cnpj);
    return response;
  } catch (error) {
    notify({
      title: "Falha",
      text: "CNPJ não encontrado!",
      type: 'error'
    });
  }
};


export const loadZipcode = async (zipcode) => {
  try {
    // use data destructuring to get data from the promise object
    const { data: response } = await axios.get('https://brasilapi.com.br/api/cep/v1/' + zipcode);
    return response;
  } catch (error) {
    notify({
      title: "Falha",
      text: "CEP não encontrado!",
      type: 'error'
    });
  }
};

export const loadBank = async () => {
  try {
    // use data destructuring to get data from the promise object
    const { data: response } = await axios.get('https://brasilapi.com.br/api/banks/v1');
    return response;
  } catch (error) {
    notify({
      title: "Falha",
      text: "Não foi possível carregar a lista bancária",
      type: 'error'
    });
  }
};